module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-red-191495a7bb943f7f904a07221cafae53.svg";